var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14426",
    "data-name": "Group 14426",
    transform: "translate(-32 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "telegram-1",
    d: "M29.734,34.99a1.923,1.923,0,0,0,1.79.235A1.877,1.877,0,0,0,32.7,33.866C34.1,27.261,37.511,10.542,38.79,4.533a1.263,1.263,0,0,0-.421-1.226,1.3,1.3,0,0,0-1.289-.226C30.3,5.591,9.413,13.427.877,16.586a1.33,1.33,0,0,0,.082,2.528c3.828,1.145,8.854,2.738,8.854,2.738s2.348,7.092,3.573,10.7a1.417,1.417,0,0,0,.975.932,1.4,1.4,0,0,0,1.312-.335l5.007-4.728s5.777,4.236,9.054,6.57ZM11.927,20.956l2.716,8.957.6-5.672L31.719,9.384a.449.449,0,0,0,.053-.61.46.46,0,0,0-.608-.1L11.927,20.956Z",
    transform: "translate(44.592 45.057)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17858",
    "data-name": "Rectangle 17858",
    width: 64,
    height: 64,
    transform: "translate(32 32)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.860953e4.svg";
export { ForwardRef as ReactComponent };